import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      z: [
        "z-fab",
        "z-floating-panel",
        "z-app-bar",
        "z-popover",
        "z-drawer",
        "z-modal",
        "z-global-loading",
        "z-message",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
